import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import useStore from 'Checkout/Hooks/useStore'
import { paymentSetData } from 'Checkout/Redux/Actions/Payment'
import { clearCart } from 'Checkout/Redux/Slices/CartSlice'
import { routesHandler } from 'Checkout/Routes/routesHandler'
import { Button, Modal, ModalBody } from 'reactstrap'

const ClearCartModal = ({ isOpen, toggle }) => {
  const container = document.getElementById('react-data-container')
  const dispatch = useDispatch()
  const { purgeStore } = useStore(container.dataset?.campgroundSlug)
  const { push } = useHistory()

  const onClearCart = () => {
    dispatch(clearCart())
    dispatch(paymentSetData({ couponCode: '' }))
    purgeStore()
    push(routesHandler.home.path)
  }

  return (
    <Modal className="modal-dialog-centered" isOpen={isOpen} size="md" toggle={toggle}>
      <ModalBody>
        <p className="text-lg mb-2">Start Over?</p>

        <p className="text-muted">
          This will remove all reservations from your cart and take you back to the beginning of the booking
          experience. Would you like to continue?
        </p>

        <div className="d-flex justify-content-between">
          <Button color="blue-dark" onClick={toggle} outline>No, go back</Button>

          <Button color="danger" onClick={onClearCart}>Clear Cart</Button>
        </div>
      </ModalBody>
    </Modal>
  )
}

export default ClearCartModal
